module.exports = __webpack_public_path__ + "img/Kuwait Office3.0b737d9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/Kuwait/Kuwait Office3.jpeg
// module id = 1714
// module chunks = 1